import { FileData, FileUploadState } from './Types';

export const selectAttachmentFolderName = (state: FileUploadState): string =>
	state.attachmentFolderName;

export const selectFileUploaded = (state: FileUploadState): FileData[] =>
	state.filesUploaded;
